import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import ListSelectBox from '../BoardModel/ListSelectBox';
import RangeInput from '../../../Component/BoardComponent/RangeInput';

const ExerciseBoxLegacy = (props) => {
  const { date, useData, setLessonId, setScheduleId, setClassTime, clickDate, rendering } = props;

  const [index, setIndex] = useState(0);
  const [isView, setIsView] = useState(true);
  const [fontSize, setFontSize] = useState(14);


  useEffect(() => {
    for (var i = 0; i < useData.length; i++) {
      if (useData[i].classDate.format('YYYY.MM.DD') === clickDate) {
        setIndex(i);
        break;
      }
    }
  }, [clickDate, useData])

  function changeFontSize(value) {
    setFontSize(value);
  }

  return (
    <TopLevelWrapper>
      <TopWrapper>
        <Title>수업</Title>
        <ListSelectBox date={date} setLessonId={setLessonId} setScheduleId={setScheduleId} setClassTime={setClassTime} rendering={rendering}/>
      </TopWrapper>
      <SubjectWrapper>
        <SubjectView>{useData[index].title}</SubjectView>
      </SubjectWrapper>
      <LineWrapper>
        <SubTitle>운동 내용</SubTitle>
        <ComponentWrapper>
          <HiddenButton onClick={() => setIsView(!isView)}>{isView ? `영상정보 숨기기` : `영상정보 보기`}</HiddenButton>
          <RangeInput defaultVal={14} changeFn={changeFontSize}/>
        </ComponentWrapper>
      </LineWrapper>
      <InfoBox>
        <ExerciseInfoWrapper>
          <Subject>준비 운동</Subject>
          {
            useData[index].warmupList.map((data, idx) => (
              <ExerciseInfoBox key={idx}>
                <ExerciseTopWrapper>
                  <ColumnSection isWarmup={true}>{String.fromCharCode(idx + 65)}</ColumnSection>
                  <TitleSection fontSize={fontSize}>{data.title}</TitleSection>
                </ExerciseTopWrapper>
                <ExerciseBodyWrapper>
                <TextSection>
                  <Text fontSize={fontSize}>{data.text}</Text>
                </TextSection>
                {isView &&
                  data.linkList.map((data, idx) => (
                    data !== '' &&
                    <VideoSection key={idx}>
                      <iframe
                        width="482"
                        height="270"
                        src={`https://www.youtube.com/embed/${data}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                      />
                    </VideoSection>
                  ))
                }
                </ExerciseBodyWrapper>
              </ExerciseInfoBox>
            ))
          }
        </ExerciseInfoWrapper>
        <ExerciseInfoWrapper>
          <Subject>운동 프로그램</Subject>
          {
            useData[index].exerciseList.map((data, idx) => (
              <ExerciseInfoBox key={idx}>
                <ExerciseTopWrapper>
                  <ColumnSection>{String.fromCharCode(idx + 65)}</ColumnSection>
                  <TitleSection fontSize={fontSize}>{data.title}</TitleSection>
                </ExerciseTopWrapper>
                <ExerciseBodyWrapper>
                <TextSection>
                  <Text fontSize={fontSize}>{data.text}</Text>
                </TextSection>
                {isView &&
                  data.linkList.map((data, idx) => (
                    data !== '' &&
                    <VideoSection key={idx}>
                      <iframe
                        width="482"
                        height="270"
                        src={`https://www.youtube.com/embed/${data}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                      />
                    </VideoSection>
                  ))
                }
                </ExerciseBodyWrapper>
              </ExerciseInfoBox>
            ))
          }
        </ExerciseInfoWrapper>
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default ExerciseBoxLegacy;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 786px;
  // min-height: 378px;
  
  padding-bottom: 28px;

  // border-radius: 30px;
  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  // background-color: #FFFFFF;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 730px;
  // max-height: 817px;
  height: 370px;
  
  margin-top: 24px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		// height: 92px;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
    // height: 439px;
		// border: 4px solid transparent;
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const LineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 730px;

  margin-top: 24px;
`;

const SubTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const HiddenButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 730px;

  // margin-top: 28px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const SubjectWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 8px;
  margin-top: 8px;
`;

const Subject = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;
`;

const SubjectView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 712px;
  height: 36px;

  padding-left: 16px;

  border: 1px solid #DFDFDF;
  border-radius: 15px;
  background-color: #FFFFFF;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;
`;

const ExerciseInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;

  margin-top: 24px;
`;

const ExerciseInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 514px;
  // min-height: 70px;
  width: 718px;
  min-height: 92px;

  margin-top: 8px;
  overflow: hidden;

  // border: 1px solid #ECECEC;
  border-radius: 15px;
  background-color: #FFFFFF;
`;

const ExerciseTopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  height: 36px;

  // border: 1px solid #ECECEC;
`;

const ExerciseBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: calc(100% - 2px);

  border: 1px solid #ECECEC;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 43px;
  height: 36px;

  background-color: ${props => props.isWarmup ? `#5BD98A` : `#FF8B48` };

  font-family: Poppins-Bold;
  font-size: 14px;

  color: #FFFFFF;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  // height: 36px;
  height: 34px;

  padding-left: 16px;

  font-family: NotoSansKR-Regular;
  // font-size: 14px;
  font-size: ${props => props.fontSize}px;

  color: #595959;

  border: 1px solid #ECECEC;
  border-top-right-radius: 15px;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
  margin: 8px 0 8px 16px;
`;

const Text = styled.pre`
  font-family: NotoSansKR-Regular;
  font-size: ${props => props.fontSize}px;

  color: #595959;

  margin: 0 0 0 0;
`;

const VideoSection = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 482px;
  height: ${props => props.modify ? 306 : 270}px;

  margin: 0 16px 16px 16px;
`;